// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__15YCH","inputWrap":"Table_inputWrap__3jmNc","col":"Table_col__5xNkw","bmiTooltip":"Table_bmiTooltip__2qhii"};